module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21\" height=\"5\" viewBox=\"0 0 21 5\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><circle cx=\"18.5\" cy=\"2.5\" r=\"2.5\"></circle><circle cx=\"10.5\" cy=\"2.5\" r=\"2.5\"></circle><circle cx=\"2.5\" cy=\"2.5\" r=\"2.5\"></circle></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true&removeSVGTagAttrs=false!./src/scripts/components/shared/MessagePreviews/WelcomeMessage/icons/menu-icon.svg
// module id = mQlq
// module chunks = 89